import { useNavigate } from 'react-router-dom';

import { routes } from 'data/routes';

import { Filters } from 'components/Filters';
import { Table } from 'components/Table';

import { OrderStats } from '../OrderStats/OrderStats';
import { useList } from './List.hooks';
import * as S from './List.styles';

export function List(): React.ReactElement {
  const {
    columns,
    ordersData,
    filters,
    register,
    setValue,
    onSubmit,
    handleSubmit,
    isOrdersLoading,
    customerCode,
  } = useList();
  const navigate = useNavigate();

  return (
    <S.Container>
      <OrderStats customerCode={customerCode} />

      <Filters
        onSubmit={handleSubmit(onSubmit)}
        filters={filters}
        register={register}
        setValue={setValue}
        type={'order.ordersByCustomerCode' as const}
      />

      {ordersData && (
        <Table
          isSortable
          columns={columns}
          data={ordersData}
          motive="tertiary"
          isLoading={isOrdersLoading}
          hasPagination
          onRowClick={(row) => {
            navigate(routes.singleOrder(row.original.orderId));
          }}
        />
      )}
    </S.Container>
  );
}
